import React, { ReactNode } from "react";
import {
  ApplicationChapterId,
  ApplicationFlows,
  ApplicationFlowSteps,
} from "./types";

interface ApplicationFlowContextType {
  flow: ApplicationFlows;
  activeChapterId: ApplicationChapterId;
  setStep: (step?: ApplicationFlowSteps) => void;
}

export const ApplicationFlowContext = React.createContext(
  {} as ApplicationFlowContextType,
);

interface ApplicationFlowProviderProps {
  children: ReactNode;
  flow: ApplicationFlows;
  activeChapter: ApplicationChapterId;
  setStep: (step: ApplicationFlowSteps) => void;
}

export default function ApplicationFlowProvider(
  props: ApplicationFlowProviderProps,
): React.JSX.Element {
  return (
    <ApplicationFlowContext.Provider
      value={{
        flow: props.flow,
        activeChapterId: props.activeChapter,
        setStep: props.setStep,
      }}
    >
      {props.children}
    </ApplicationFlowContext.Provider>
  );
}
